<ng-container>
	<app-digital-banner></app-digital-banner>
	<div class="d-l-module" *ngFor="let feed of feedResponses">
		<div class="d-feeds-container">
			<div class="d-feeds-content">
				<div class="d-feed-content">
					<ng-container [ngSwitch]="state">
						<div [innerHTML]="feed.content" appEheAnalytics [data]="analyticsData"></div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<ng-container *ngIf="showPDF">
	<div class="pdf-wrapper">
		<div class="pdf-title-wrapper">
			<div class="pdf-title">
				<span class="text-left">2020-productchanges</span>
				<span class="text-right close" (click)="closePdf()"> <i class="fas fa-times"></i></span>
			</div>
		</div>
		<div class="content">
			<pdf-viewer
				[src]="url"
				[ngClass]="autoResize ? 'd-block' : ''"
				[render-text]="true"
				[original-size]="!autoResize"
				[show-all]="true"
				[autoresize]="autoResize"
				(page-rendered)="renderPage($event)"
				(error)="errorCallback($event)"></pdf-viewer>
		</div>
	</div>
</ng-container>
